<template>
  <Loader v-if="loadActivity || !countries" />
  <main v-else-if="!activity" class="contentShare">
    <img class="contentShare__logo" src="../assets/SPALogo-small.svg" alt="Forge Fondation" />
    <h1 class="contentShare__title">
      Actividad de la clase
    </h1>

    <span class="contentShare__subtitle">Completa lo siguientes datos básicos para ingresar a la actividad:</span>

    <form @submit.prevent="!completeFormEnabled && checkEmail() || sendReferred()" class="contentShare__form"> 
      <Input 
        id="email"
        label="Email"
        v-model="formModel.email"
        :disabled="completeFormEnabled"
      />

      <template v-if="completeFormEnabled">
        <Input 
          id="firstname"
          label="Nombre"
          v-model="formModel.firstname"
        />

        <Input 
          id="lastname"
          label="Apellido"
          v-model="formModel.lastname"
        />

        <DatePicker 
          id="birthday"
          label="Fecha de nacimiento"
          v-model="formModel.birthDate"
        />

        <Select 
          mode="simple"
          id="country"
          label="Pais"
          :values="countries"
          valueLabel="name"
          valueProp="id"
          v-model="formModel.countryId"
        />


      </template>

      <button 
        type="submit" 
        class="contentShare__submit"
        :disabled="(!completeFormEnabled && v$.formModel.email.$invalid) || submitting || (completeFormEnabled && v$.formModel.$invalid)"
      >
        Continuar <i class="material-icons-outlined">arrow_forward</i>
      </button>
    </form>


    <span class="contentShare__termsAndConditions">
      Haciendo click en “Continuar” aceptas los <a :href="`/terms.pdf?v=${linkRandParam}`" target="_blank">Términos y Condiciones y las Políticas de Privacidad</a> de Forge Foundation
    </span>


  </main> 
  <main class="contentShareActivity" v-else>
    <button class="contentShareActivity__logout" @click="logout()">Cerrar sesión</button>
    <img class="contentShare__logo" src="../assets/SPALogo-small.svg" alt="Forge Fondation" />
    <h3 style="font-weight: 700; font-size: 20px;" >Te invitamos a realizar la siguiente actividad: </h3>
    <div class="container-genially" v-html="activity"></div>
    <span style="font-weight: 700; font-size: 15px;">¿Te gustaría saber más acerca de lo que hacemos en Forge?</span>
    <p style="font-weight: 400; font-size: 15px;">Conoce más acerca de cómo ayudamos a miles de jóvenes en toda Latinoamerica a conseguir herramientas para la búsqueda de su primer trabajo en <a href="https://fondationforge.org/tu-futuro" target="_blank">www.fondationforge.org/tu-futuro</a></p>
  </main>
</template>

<script>
import { onMounted, onUnmounted, ref } from 'vue'
import Input from '../components/Input.vue'
import DatePicker from '../components/Inputs/DatePicker.vue'
import Select from '../components/Inputs/Select.vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { required, email } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import Loader from '../components/Loader.vue'
import Cookies from 'js-cookie';
export default {
  components: {
    Input,
    DatePicker,
    Select,
    Loader
},
  setup() { 
    const formModel = ref({
      email: undefined,
      firstname: undefined,
      lastname: undefined,
      birthDate: undefined,
      password: null,
      countryId: undefined
    })
    const store = useStore()
    const submitting = ref(false)
    const route = useRoute()
    const v$ = useVuelidate()
    const completeFormEnabled = ref(false)
    const viewActivity = ref(false)
    const loadActivity = ref(false)
    const activity = ref(undefined)
    const refreshCookie = ref()
    const countries = ref()
    const linkRandParam = Math.round(Math.random()*1000);

    const logout = () => {
      clearInterval(refreshCookie.value)
      Cookies.remove('contentshareauth')
      activity.value = undefined
    }

    const checkEmail = async () => {
      if (submitting.value) return
      try {
        submitting.value = true
        let req = {
          identifier: route.params.id,
          email: formModel.value.email
        }
        const {data} = await store.dispatch('contentShare__checkEmail', req)
        if (!data.userExists) {
          completeFormEnabled.value = true
        } else {
          getActivty()
        }
      } catch (err) {
        console.log(err)
        if (err.response && (err.response.data === "INVALID_IDENTIFIER" || err.code === "ERR_BAD_REQUEST")) {
          store.dispatch('notifications_create', { text: 'La url que intenta acceder no existe.' })
          return
        }
        store.dispatch('notifications_create', { text: 'Ha ocurrido un error verificando el email.' })
      } finally {
        submitting.value = false
      }
    }

    const sendReferred = async () => {
      if (submitting.value) return
      try {
        submitting.value = true
        let body = {
          identifier: route.params.id,
          req: formModel.value
        }
        await store.dispatch('contentShare__sendUser', body)
        getActivty()
      } catch (err) {
        console.log(err)
        store.dispatch('notifications_create', { text: 'Ha ocurrido un error.' })
      } finally {
        submitting.value = false
      }
    }

    const getActivty = async () => {
      try {
        loadActivity.value = true
        const { data } = await store.dispatch('contentShare__activity', route.params.id)
        let contents = JSON.parse(data.data)
        activity.value = contents.Subcontents.find(content => content.Identifier === contents.SelectedOption)?.SharedTab
        setCookie()
        refreshCookie.value = setInterval(() => {
          setCookie();
        }, 3 * 60 * 1000)
      } catch (err) {
        console.log(err)
        store.dispatch('notifications_create', { text: 'Ha ocurrido un error.' })
      } finally{
        loadActivity.value = false
      }
    }

    const getCountries = async () => {
      try {
        const {data} = await store.dispatch('stuff__countries')
        countries.value = data
      } catch (err) {
        console.log(err)
        store.dispatch('notifications_create', {text: 'Ha ocurrido un error.'})
      }
    }

    const setCookie = () => {
      const fechaExpiracion = new Date();
      fechaExpiracion.setTime(fechaExpiracion.getTime() + 3 * 60 * 1000);
      Cookies.set('contentshareauth', 'true', { expires: fechaExpiracion, path: route.path });
    }

    onMounted(() => {
      getCountries()
      if (Cookies.get('contentshareauth')) {
        getActivty()
        refreshCookie.value = setInterval(() => {
          setCookie();
        }, 3 * 60 * 1000)
      }
    })

    onUnmounted(() => {
      clearInterval(refreshCookie.value)
    })

    return {
      formModel,
      submitting,
      checkEmail,
      v$,
      completeFormEnabled,
      sendReferred,
      viewActivity,
      getActivty,
      activity,
      loadActivity,
      logout,
      countries,
      linkRandParam
    }
  },
  validations() {
    return {
      formModel: {
        email: { required, email },
        firstname: { required },
        lastname: { required },
        birthDate: { required },
        countryId: { required }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.contentShareActivity{
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: fit-content;
  margin: 0 auto;
  padding: 48px 16px;
  .contentShare__logo{
    margin: 0;
  }
  &__logout{
    border: 1px solid $green;
    border-radius: 44px;
    font-weight: 600;
    font-size: 16px;
    color: $green;
    background-color: inherit;
    cursor: pointer;
    align-self: flex-end;
    padding: 8px 22px;
  }
  .container-genially{
    width: 100%;
    max-width: 900px;
    margin: 16px 0;
    align-self: center;
  }
}

.contentShare{
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 36px;
  margin: 0 auto;
  width: 100%;
  max-width: 350px;
  padding: 48px 0;

  &__logo{
    width: 81px;
    // height: 67px;
    margin: 0 auto;
  }
  &__title{
    font-size: 20px;
    font-weight: 600;
    color: #212121;
  }
  &__subtitle{
    font-size: 16px;
    font-weight: 600;
    color: #212121;
  }
  &__submit{
    color: #fff;
    background-color: $green;
    padding: 12px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    border-radius: 44px;
    margin-top: 22px;
    &:disabled{
      cursor: default !important;
      opacity: .6;
    }
    .material-icons-outlined{
      font-size: 18px;
    }
  }
  &__termsAndConditions{
    font-size: 11px;
    font-weight: 400;
    a{
      color: $green;
    }
  }
  &__form{
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
}
</style>